/* eslint-disable prefer-destructuring */
import { toSlug } from '@/utils/common';
import { pr } from '@/utils/pxToRem';
import { Stack, Link, Grid } from '@mui/material';
import React, { useMemo } from 'react';
import AIRPORT_VN from '@/mappings/airport_vn.json';
import { slugify } from '@/utils/stringConvert';
import { genLinkSeo, genLinkSeoForVexPage } from '@/utils/genLinkSeo';

interface SectionFamousRouteProps {
  startPoint: any;
}

const SectionFamousRoute: React.FC<SectionFamousRouteProps> = ({
  startPoint,
}) => {
  const key = startPoint?.airports[0]?.airportCode;
  const listRoute = (AIRPORT_VN as any).routes[key];
  if (listRoute?.length > 10) {
    listRoute.length = 10;
  }
  const [list1, list2] = useMemo(() => {
    const copyListRoute = JSON.parse(JSON.stringify(listRoute));
    const tempList1 = copyListRoute.splice(0, 5);
    return [tempList1, copyListRoute];
  }, [listRoute, startPoint]);
  return (
    <Grid
      container
      marginTop={pr`16px`}
    >
      <Grid
        item
        xs={12}
        md={6}
      >
        <Stack spacing="16px">
          {list1?.map((airpotCode: string) => {
            const areaData = AIRPORT_VN.airports.find(
              (item) => item.AirportCode === airpotCode,
            );
            return (
              <Link
                sx={{
                  fontWeight: 500,
                  textDecoration: 'none',

                }}
                // href={`/vn/ve-may-bay/tu-${toSlug(startPoint.location)}${slugify(startPoint?.location) !== slugify(startPoint?.stateName) ? `-${slugify(startPoint?.stateName)}` : ''}-di-${toSlug(
                //   areaData?.CityName_Vi || '',
                // )}${slugify(areaData?.CityName_Vi || '') !== slugify(areaData?.stateName || '') ? `-${slugify(areaData?.stateName || '')}` : ''}.${startPoint.id}.${areaData?.VxrAreaParentId}.vi`}
                href={genLinkSeo({
                  startName: startPoint.location,
                  startId: startPoint.id,
                  startStateName: startPoint?.stateName,
                  endName: areaData?.CityName_Vi,
                  endId: +(areaData?.VxrAreaParentId || 0),
                  endStateName: areaData?.stateName,
                })}
                key={airpotCode}
              >
                {` Vé máy bay giá rẻ từ
            ${startPoint.location}
            đi 
            ${areaData?.CityName_Vi}
            `}
              </Link>
            );
          })}

        </Stack>

      </Grid>
      <Grid
        item
        xs={12}
        md={6}

      >
        <Stack spacing="16px">
          {list2?.map((airpotCode: string) => {
            const areaData = AIRPORT_VN.airports.find(
              (item) => item.AirportCode === airpotCode,
            );
            return (
              <Link
                sx={{
                  fontWeight: 500,
                  textDecoration: 'none',
                }}
                // href={`/vn/ve-may-bay/tu-${toSlug(startPoint.location)}${slugify(startPoint?.location) !== slugify(startPoint?.stateName) ? `-${slugify(startPoint?.stateName)}` : ''}-di-${toSlug(
                //   areaData?.CityName_Vi || '',
                // )}${slugify(areaData?.CityName_Vi || '') !== slugify(areaData?.stateName || '') ? `-${slugify(areaData?.stateName || '')}` : ''}.${startPoint.id}.${areaData?.VxrAreaParentId}.vi`}
                href={genLinkSeo({
                  startName: startPoint.location,
                  startId: startPoint.id,
                  startStateName: startPoint?.stateName,
                  endName: areaData?.CityName_Vi,
                  endId: +(areaData?.VxrAreaParentId || 0),
                  endStateName: areaData?.stateName,
                })}
                key={airpotCode}
              >
                {` Vé máy bay giá rẻ từ
            ${startPoint.location}
            đi 
            ${areaData?.CityName_Vi}
            `}
              </Link>
            );
          })}

        </Stack>

      </Grid>
    </Grid>
  );
};

export default SectionFamousRoute;
